"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceStatWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_2 = tslib_1.__importDefault(require("react"));
var SingleWatcher_1 = require("../SingleWatcher");
var getWorkspaceStatRefClient_1 = require("../../../functions/utilities/ref/get/getWorkspaceStatRefClient");
var firestore_1 = require("firebase/firestore");
exports.WorkspaceStatWatcher = (0, react_1.memo)(function (_a) {
    var workspaceId = _a.workspaceId, onNext = _a.onNext, clearWorkspaceStat = _a.clearWorkspaceStat;
    var refCallback = (0, react_1.useCallback)(function () {
        return (0, getWorkspaceStatRefClient_1.getWorkspaceStatRefClient)({
            firestore: (0, firestore_1.getFirestore)(),
            workspaceId: workspaceId,
        });
    }, [workspaceId]);
    var onNextCallback = (0, react_1.useCallback)(function (docSnapshot) {
        onNext({ docSnapshot: docSnapshot, workspaceId: workspaceId });
    }, [onNext, workspaceId]);
    var watcherKey = 'workspaceStat';
    return (react_2.default.createElement(SingleWatcher_1.SingleWatcher, { onNext: onNextCallback, getRef: refCallback, onUnsubscribe: clearWorkspaceStat, watcherKey: watcherKey }));
});
